import { Chart, ChartSeries, ChartSeriesItem, ChartCategoryAxis, ChartCategoryAxisItem, ChartTitle, ChartLegend } from "@progress/kendo-react-charts";
import { useApiTrigger } from '../../hooks/useApiTrigger';
import { forwardRef, useImperativeHandle } from "react";

const AreaChart = forwardRef(({ data, filters, returnData }, ref) => {
    const { dto } = useApiTrigger(data, filters);

    const getData = () => {
        const fileName = data.accion || 'Reporte_Grafica';
        returnData(dto, fileName);
    };

    useImperativeHandle(ref, () => ({
        exportChartData: getData,
    }));

    return (
        <Chart style={{ width: "100%", height: "100%" }}>
            <ChartTitle text={data.accion} />
            <ChartLegend position="top" orientation="horizontal" />
            <ChartCategoryAxis>
                <ChartCategoryAxisItem
                    categories={dto.map(item => item.category)}
                    startAngle={45}
                />
            </ChartCategoryAxis>
            <ChartSeries>
                <ChartSeriesItem
                    type="area"
                    data={dto.map(item => item.value)}
                    tooltip={{ visible: true }}
                />
            </ChartSeries>
        </ Chart >
    )
});
export default AreaChart;